import { validateEmail, validateIndonesianPhoneNumber } from "../utils";

export const required = message => {
  const isRequired = value => {
    if(Array.isArray(value)){
      return value.length > 0? null : message || "This field is required";
    }
    return value? null :  message || "This field is required";
  };
  return isRequired;
};
export const email = message => {
  const validEmail = value => validateEmail(value)? null : message || "Email is not valid";
  return validEmail;
};
export const minLength = (length, message) => {
  const validLength = (value) => value.length >= length? null: message || "This field is required";
  return validLength;
};
export const phone = message => {
  const validPhone = value => validateIndonesianPhoneNumber(value)? null : message || "Phone number is not valid";
  return validPhone;
};

export const arrayOfObject = (validator) => {
  return {
    type:"ARRAY_OF_OBJECT",
    validator
  }
}

/**
 * Recursively validates data using validators, supporting nested objects.
 * @param {Object} data - The data to validate.
 * @param {Object} validators - The validators for each field (can be nested). or can be array of object using funtion arrayOfObject
 * @returns {Object} { isValid, errors }
 */
export function validate(data, validators) {
  let isValid = true;
  let errors = {};
  for (const key in validators) {
    const validatorEntry = validators[key];
    const dataEntry = data? data[key]: undefined;
    if (validatorEntry.type && typeof validatorEntry === "object" && validatorEntry.type === "ARRAY_OF_OBJECT") {
      errors[key] = [];
      for (let i = 0; i < dataEntry.length; i++) {
        const itemResult = validate(dataEntry[i], validatorEntry.validator);
        errors[key][i] = itemResult.errors;
        if (!itemResult.isValid) isValid = false;
      }
    } else if (typeof validators[key] === "object" && !Array.isArray(validators[key])) {
      // Nested object: recurse
      const nestedResult = validate(data[key] || {}, validators[key]);
      errors[key] = nestedResult.errors;
      if (!nestedResult.isValid) isValid = false;
    } else {
      // Array of validators
      errors[key] = null;
      for (const validator of validators[key]) {
        const error = validator(dataEntry);
        if (error) {
          errors[key] = error;
          isValid = false;
          break;
        }
      }
    }
  }

  return { isValid, errors };
}


/**
 * Recursively validates data using validators, supporting nested objects and arrays of objects.
 * @param {Object} data - The data to validate.
 * @param {Object} validators - The validators for each field (can be nested or arrays).
 * @returns {Object} { isValid, errors }
 */
// export function validate(data, validators) {
//   let isValid = true;
//   let errors = {};

//   for (const key in validators) {
//     const validatorEntry = validators[key];
//     const dataEntry = data[key];

//     // check if validatorEntry indicates an array of objects
//     if (typeof validatorEntry === "object" && validatorEntry.type === "ARRAY_OF_OBJECT") {
//       errors[key] = [];
//       for (let i = 0; i < dataEntry.length; i++) {
//         const itemResult = validate(dataEntry[i], validatorEntry);
//         errors[key][i] = itemResult.errors;
//         if (!itemResult.isValid) isValid = false;
//       }
//     }
//     if (Array.isArray(dataEntry) && Array.isArray(validatorEntry)) {
//       // Array of primitives: apply all validators to the array itself
//       errors[key] = null;
//       for (const validator of validatorEntry) {
//         const error = validator(dataEntry);
//         if (error) {
//           errors[key] = error;
//           isValid = false;
//           break;
//         }
//       }
//     } else if (typeof validatorEntry === "object" && !Array.isArray(validatorEntry)) {
//       // Nested object: recurse
//       const nestedResult = validate(dataEntry || {}, validatorEntry);
//       errors[key] = nestedResult.errors;
//       if (!nestedResult.isValid) isValid = false;
//     } else if (Array.isArray(validatorEntry)) {
//       // Array of validators for primitive value
//       errors[key] = null;
//       for (const validator of validatorEntry) {
//         const error = validator(dataEntry);
//         if (error) {
//           errors[key] = error;
//           isValid = false;
//           break;
//         }
//       }
//     }
//   }

//   return { isValid, errors };
// }


// WEBPACK FOOTER //
// ./src/utils/objectValidation.js